export enum FluxoCaixaTipoDetalheEnum {
  Recebimento = 1,
  Pagamento = 2,
  TransferenciaEntrada = 3,
  TransferenciaSaida = 4
}
